import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingView from '../../../../components/LoadingView';
import { EMMA_MY_PRIVILEGES_MODULE_NAME } from '../../../../constants/constants';
import { t } from '../../../../locales';
import { EmmaPartnerService } from '../../../../modules/home/types/EmmaPartnerService';
import {
  COMPONENT_MOUNTED,
  FETCH_MY_PRIVILEGES_FEATURES,
  switchCurrentTab,
} from '../../../../modules/myPrivileges/actions/myPrivilegesAction';
import { MyPrivilegesBanner } from '../../../../modules/myPrivileges/components/MyPrivilegesBanner';
import { MyPrivilegesCardList } from '../../../../modules/myPrivileges/components/MyPrivilegesCardList';
import {
  getCurrentTab,
  getIsLoadingPage,
  getMyPrivilegesConfig,
  getMyPrivilegeSections,
} from '../../../../modules/myPrivileges/selectors/myPrivilegesSelector';
import { getToken } from '../../../../selectors/authSelectors';
import { getLanguage } from '../../../../selectors/userSelectors';
import { put, select } from '../../../../stores';
import {
  extractRelativeUrl,
  getValidToken,
  resolveLocalizedText,
  resolvePublicAssets,
  setSkipSidebarToMyPrivileges,
} from '../../../../utils';
import { addCorpWebIndicator } from '../../../../utils/emmaUrlConverter';
import { startBannerRouting } from '../../../emma-common/actions/bannerRoutingActions';
import {
  getCwpPartnerServiecs,
  getMyPrivilegesFeatures,
  getMyPrivilegesFeaturesError,
  getPoPartnerServiecs,
  isCWP,
} from '../../../home/selectors/serviceSelectors';
import { OffersContainer } from '../../../offers/containers/OffersContainerRevamp';
import BackNavButton from '../../components/BackNavButton';
import './styles.scss';

import { EmmaSpace, EmmaTabs } from '@axa-asia/emma-stylesheet';
import EmmaModalView from '../../../../components/EmmaModalView';
import EMMAContactCallModel from '../../../../components/EmmaModalView/ContactCallModel';
import EmmaTncStyleModel from '../../../../components/EmmaModalView/TncStyleModel';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../utils/generalGaEventAnalytics';
import VhisModalView from '../../../axagoal/components/VhisModalView';
import { getCorpWebIndicatorConfig } from '../../../emma-webview/selectors/webviewSelector';
// import { fetchOffers } from '../../../offers/actions/offersFormAction';

export interface MyPrivilegesContainerProps {
  myPrivilegesConfig: MyPrivilegesConfigProps;
  isCWP: boolean;
  myPrivilegesFeatureItemConfig: any;
  getProfileAPIFail: any;
  OffersConfig: any;
  lang: 'en' | 'zh';
  currentTab: string;
  goToswitchCurrentTab: Function;
  offersFeatures: any;
  callStartBannerRouting: Function;
  // fetchOffers: Function;
  isLoadingPage: boolean;
}

export interface MyPrivilegesConfigProps {
  title?: string;
  banner: {
    largeViewPointImage?: string;
    smallViewPointImage?: string;
    title: string;
    subtitle?: string;
    desc: string;
    descCharLength: number;
    descMore?: string;
    descLess?: string;
    knowMore?: object;
  };
  sections: {
    id: string;
    subFeatureIds: Array<string>;
    title?: string;
    additionalCards?: any;
  }[];
}

export interface MyPrivilegesContainerState {
  isShowBackButton: boolean;
  currentTab: string;
}

export class MyPrivilegesContainer extends Component<
  MyPrivilegesContainerProps,
  MyPrivilegesContainerState
> {
  constructor(props: any = {}) {
    super(props);
    this.state = {
      isShowBackButton: false,
      currentTab: 'privileges',
    };
  }

  componentDidMount() {
    put({
      type: COMPONENT_MOUNTED,
    });
    put({
      type: FETCH_MY_PRIVILEGES_FEATURES,
    });

    // this.props.fetchOffers();

    const relativeUrl = extractRelativeUrl();
    const segments = relativeUrl.split(`/`).filter((s) => !!s);
    const isShowBackButton =
      _.lastIndexOf(segments, 'myprivileges') == 1 && segments.length == 2
        ? true
        : false;
    this.setState({ isShowBackButton: isShowBackButton });
    setSkipSidebarToMyPrivileges();

    this.switchTabByUrlHash();
  }

  switchTabByUrlHash() {
    try {
      if (window.location && window.location.hash) {
        const targetTab = window.location.hash.replace('#', '');
        this.props.goToswitchCurrentTab(targetTab);
      }
    } catch (err) {
      console.error(err);
    }
  }

  onSwitchTab(currentTab: string) {
    this.props.goToswitchCurrentTab(currentTab);
  }

  onClickToGatc(currentTab: string) {
    // ga#CWP3 ga#CWP4
    try {
      const tcWindow: any = window;
      const token = select(getToken);
      const aToken = getValidToken(token);
      // const pathName = window.location.pathname;
      const screenName =
        currentTab === 'offers'
          ? `${getGaPagePath()}#privileges`
          : `${getGaPagePath()}#offers`;
      const tap = currentTab === 'Offers' ? 'offers' : 'privileges';
      const event =
        currentTab === 'offers' ? 'clickOfferTab' : 'clickPrivilegeTab';

      tcWindow.dataLayer.push({
        event: event,
        offerTab: tap,
        screenName: screenName,
        userId: aToken,
      });

      tcWindow.dataLayer.push({
        event: 'screenView',
        page: `/emma-webportal/marketplace/myprivileges#${tap}`,
        userId: aToken,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (currentTab === 'Offers') {
      //   if (!isApp()) {
      //     tcWindow.tC.event.clickOfferTab(tcWindow, {
      //       offerTab: 'offers',
      //       screenName: screenName,
      //       AXAID: aToken,
      //     });
      //     tcWindow.tC.event.virtualPageview(tcWindow, {
      //       page: `/emma-webportal/marketplace/myprivileges#offers`,
      //       AXAID: aToken,
      //     });
      //   }
      // } else {
      //   if (!isApp()) {
      //     tcWindow.tC.event.clickPrivilegeTab(tcWindow, {
      //       privilegeTab: 'privileges',
      //       screenName: screenName,
      //       AXAID: aToken,
      //     });
      //     tcWindow.tC.event.virtualPageview(tcWindow, {
      //       page: `/emma-webportal/marketplace/myprivileges#privileges`,
      //       AXAID: aToken,
      //     });
      //   }
      // }
    } catch (e) {
      handleGaError(e);
    }
  }

  render() {
    const {
      currentTab,
      myPrivilegesConfig,
      getProfileAPIFail,
      // OffersConfig,
      lang,
      // offersFeatures,
      isLoadingPage,
    } = this.props;
    const { isShowBackButton } = this.state;

    return (
      <div className="myprivileges-container">
        <EmmaModalView />
        <VhisModalView />
        <EmmaTncStyleModel />
        <EMMAContactCallModel />
        {isShowBackButton && (
          <div className="myprivileges-backbutton">
            <BackNavButton />
          </div>
        )}
        <div className="emma-stylesheet-grid-system myprivileges-content">
          {(getProfileAPIFail ||
            !myPrivilegesConfig.sections ||
            isLoadingPage) && <LoadingView />}
          {!getProfileAPIFail &&
            myPrivilegesConfig.sections &&
            myPrivilegesConfig.title && (
              <div className="myprivileges-container__title">
                {myPrivilegesConfig.title}
              </div>
            )}
        </div>
        <div className={EmmaSpace.pb8}>
          <EmmaTabs
            value={currentTab}
            onChange={(tab) => this.onSwitchTab(tab)}
            tabs={[
              {
                key: 'privileges',
                label: t('UI_MY_PRIVILEGES_TAB_PRIVILEGES'),
              },
              {
                key: 'offers',
                label: t('UI_MY_PRIVILEGES_TAB_OFFERS'),
              },
            ]}
            isFullWidthInMobile
            isEvenlyDistributed
            mode="default"
          />
        </div>

        <div className="emma-stylesheet-grid-system myprivileges-content">
          {/* privileges */}
          {currentTab === 'privileges' && (
            <div>
              {!getProfileAPIFail &&
                myPrivilegesConfig.sections &&
                myPrivilegesConfig.banner && (
                  <MyPrivilegesBanner banner={myPrivilegesConfig.banner} />
                )}
              {!getProfileAPIFail && myPrivilegesConfig.sections && (
                <div className="myprivileges-container__section-container-list">
                  {myPrivilegesConfig.sections &&
                    myPrivilegesConfig.sections.map((sec) => {
                      return (
                        sec.id &&
                        myPrivilegesConfig.sections &&
                        myPrivilegesConfig.sections.length > 0 &&
                        sec.subFeatureIds.length > 0 && (
                          <div
                            className="myprivileges-container__section-container"
                            key={sec.title}
                          >
                            {sec.title && (
                              <div className="myprivileges-container__section-title">
                                {sec.title}
                              </div>
                            )}
                            <MyPrivilegesCardList
                              cardViewIds={sec.subFeatureIds}
                            />
                          </div>
                        )
                      );
                    })}
                </div>
              )}
            </div>
          )}
          {/* offers */}
          {currentTab === 'offers' && <OffersContainer lang={lang} />}
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const lang = getLanguage(state);

    // myPrivileges config
    const myPrivilegesConfig = getMyPrivilegesConfig(state);
    const banner = myPrivilegesConfig.banner;
    const title = myPrivilegesConfig.title;

    const knowMoreTmp: any = {};
    if (banner && banner.knowMore) {
      knowMoreTmp.label = banner.knowMore.label
        ? resolveLocalizedText(banner.knowMore.label)
        : '';
      knowMoreTmp.deepLink = banner.knowMore.deepLink
        ? addCorpWebIndicator({
            url: banner.knowMore.deepLink.replace(`\${language}`, lang),
            ...getCorpWebIndicatorConfig(state),
          })
        : '';
    }

    const { myPrivilegesFeaturesError, myPrivilegesFeatureSections } =
      MyPrivilegesContainer.getMyPrivilegesFeatureSectionsSorted(state);

    const currentTab = getCurrentTab(state);

    // HKEMMA-99501: offers API decommission - depreciated in Emma1.5
    // Tracker platform for offer URL
    // const offerConfig = getOffersConfig(state);
    // const offersFeaturesConfig = getOffersFeaturesConfig(state);
    // if (offerConfig && offerConfig.offerSections) {
    //   offerConfig.offerSections.forEach((detail: any) => {
    //     if (detail && detail.cards) {
    //       detail.cards.forEach((card: any) => {
    //         if (
    //           card &&
    //           card.cardDeepLink &&
    //           card.cardDeepLink.query &&
    //           card.cardDeepLink.query.url
    //         ) {
    //           card.cardDeepLink.query.url = addCorpWebIndicator({
    //             url: card.cardDeepLink.query.url,
    //             ...getCorpWebIndicatorConfig(state),
    //           });
    //         }
    //       });
    //     }
    //   });
    // }

    return {
      getProfileAPIFail: myPrivilegesFeaturesError,
      myPrivilegesConfig: {
        title: myPrivilegesConfig.title ? resolveLocalizedText(title) : '',
        banner: {
          largeViewPointImage:
            banner && banner.largeViewPointImage
              ? resolvePublicAssets(banner.largeViewPointImage)
                  .replace('.png', '@3x.png')
                  .replace('.jpg', '@3x.jpg')
              : '',
          smallViewPointImage:
            banner && banner.smallViewPointImage
              ? resolvePublicAssets(banner.smallViewPointImage)
                  .replace('.png', '@3x.png')
                  .replace('.jpg', '@3x.jpg')
              : '',
          title:
            banner && banner.title ? resolveLocalizedText(banner.title) : '',
          subtitle:
            banner && banner.subtitle
              ? resolveLocalizedText(banner.subtitle)
              : '',
          desc: banner && banner.desc ? resolveLocalizedText(banner.desc) : '',
          descCharLength:
            banner && banner.descCharLength ? banner.descCharLength : 0,
          descMore:
            banner && banner.descMore
              ? resolveLocalizedText(banner.descMore)
              : '',
          descLess:
            banner && banner.descLess
              ? resolveLocalizedText(banner.descLess)
              : '',
          knowMore: knowMoreTmp,
        },
        sections: myPrivilegesFeatureSections,
      },
      isCWP: isCWP(state),
      // HKEMMA-99501: offers API decommission - depreciated in Emma1.5
      // OffersConfig: offerConfig,
      // offersFeatures: offersFeaturesConfig,
      lang: lang,
      currentTab,
      isLoadingPage: getIsLoadingPage(state),
    };
  }

  private static getMyPrivilegesFeatureSectionsSorted(state: any) {
    const myPrivilegesFeatureSections = [];
    const myPrivilegesFeaturesError = getMyPrivilegesFeaturesError(state);
    const myPrivilegeSections = getMyPrivilegeSections(state);
    const myPrivilegesFeatures = getMyPrivilegesFeatures(state) || {};

    const visibleCardViewIds: Array<string> =
      MyPrivilegesContainer.getVisibleCardViewIds(state);

    const myPrivilegesFeatureList: Array<any> =
      myPrivilegesFeatures.features || [];
    myPrivilegesFeatureList.sort(
      (a: { featureRank: number }, b: { featureRank: number }) => {
        return a.featureRank - b.featureRank;
      },
    );

    for (const feature of myPrivilegesFeatureList) {
      const { featureName: featureId, subFeatures } = feature;

      const correspondingSection = myPrivilegeSections.find(
        (section) => section.id === featureId,
      );
      if (!correspondingSection) {
        console.warn(`Section "${featureId}" not found`);
        continue;
      }
      const subFeatureIds: Array<string> = subFeatures.filter((id: string) =>
        visibleCardViewIds.includes(id),
      );

      myPrivilegesFeatureSections.push({
        id: featureId,
        title: correspondingSection.title
          ? resolveLocalizedText(correspondingSection.title)
          : '',
        additionalCards: correspondingSection.additionalCards
          ? correspondingSection.additionalCards
          : [],
        subFeatureIds,
      });
    }

    return { myPrivilegesFeaturesError, myPrivilegesFeatureSections };
  }

  private static getVisibleCardViewIds(state: any) {
    const partnerServices: Array<EmmaPartnerService> = !isCWP(state)
      ? (getPoPartnerServiecs(state) as Array<EmmaPartnerService>)
      : (getCwpPartnerServiecs(state) as Array<EmmaPartnerService>);
    if (!partnerServices) {
      return [];
    }
    const filterPartnerServices = partnerServices.filter(
      (ps) =>
        ps.groupIds && ps.groupIds.includes(EMMA_MY_PRIVILEGES_MODULE_NAME),
    );
    const visibleCardViewIds: Array<string> = filterPartnerServices
      .filter((ps) => ps.visible)
      .map((ps) => ps.id);
    return visibleCardViewIds;
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      goToswitchCurrentTab: (currentTab: string) => {
        dispatch(switchCurrentTab(currentTab));
      },
      callStartBannerRouting: (query: any) => {
        dispatch(startBannerRouting(query));
      },
      // HKEMMA-99501: offers API decommission - depreciated in Emma1.5
      // fetchOffers: () => {
      // dispatch(fetchOffers());
      // },
    };
  }
}

export default connect(
  MyPrivilegesContainer.mapStateToProps,
  MyPrivilegesContainer.mapDispatchToProps,
)(MyPrivilegesContainer);
